import { render, staticRenderFns } from "./Entrepreneur.vue?vue&type=template&id=3db10185"
import script from "./Entrepreneur.vue?vue&type=script&lang=ts"
export * from "./Entrepreneur.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports